import { render, staticRenderFns } from "./polist.vue?vue&type=template&id=6a40135e"
import script from "./polist.vue?vue&type=script&lang=js"
export * from "./polist.vue?vue&type=script&lang=js"
import style0 from "./polist.vue?vue&type=style&index=0&id=6a40135e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports